// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2235":"a2b269d91708a153","7355":"2546ba49968471c9"}[chunkId] + ".css";
};